import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

export const phoneCodeApi = createApi({
  reducerPath: 'phoneCodeApi',
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 5,
  endpoints: (builder) => ({
    getPhoneCodeList: builder.query({
      query: () => ({
        method: 'GET',
        path: 'PublicData/GetPhoneCodes',
      }),
    }),
  }),
});

export const phoneCodeApiReducerName = phoneCodeApi.reducerPath;
export const phoneCodeApiReducer = phoneCodeApi.reducer;
export const phoneCodeApiMiddleware = phoneCodeApi.middleware;

export const { useGetPhoneCodeListQuery } = phoneCodeApi;
